import MenyLocalStorage from "@app/MenyLocalStorage"
import { AppNewsData } from "../pages/NewsPopup"
import PathNames from "@app/const/PathNames"
import BbSesong from "@resources/icons/BbSesong"

export const NewsConfig: AppNewsData[] = [
    {
        title: " ”Tilbud” heter nå “Gode kjøp”!",
        text: "Nå finner du alle gode kjøp samlet under ett sted i appen, og der finner du alt fra tilbud og faste knallkjøp til dine personlige kuponger og bonuskampanjer. Se etter “Gode kjøp” i menyen under.",
        linkPath: PathNames.BestBuy,
        // cloudinaryId: "loltoxrbmhqkeph4y17v",
        icon: BbSesong,
        localStorageKey: MenyLocalStorage.UserSeenAppNewsBestBuyPopup,
        validFrom: new Date("2025-11-04"),
    },

    // {
    //     title: "Gjør mer med Trumf-bonusen din i appen!💰",
    //     text: "Nå kan du enkelt velge om du vil bruke Trumf-bonusen din som betaling på MENY, donere til veldedighet, la den stå og spar til en reise, eller overfør til bankkontoen din og bruk den på det du vil. Ka-ching!",
    //     linkPath: PathNames.UseBonus,
    //     cloudinaryId: "loltoxrbmhqkeph4y17v",
    //     localStorageKey: MenyLocalStorage.UserSeenAppNewsTrumfBonusPopup,
    //     validFrom: new Date("2024-09-04"),
    // },
]
